import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LanguageInterface } from '../translate-form.component';
import { ButtonList } from 'src/app/system-utils/actions-buttons/actions-buttons.component';
import { FormServices } from 'src/app/services/form.services';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { LanguageServices } from 'src/app/services/LanguageServices';
import { ThemeService } from 'src/app/services/theme.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-translate-form-new',
  standalone: false,
  templateUrl: './translate-form-new.component.html',
  styleUrl: './translate-form-new.component.scss'
})
export class TranslateFormNewComponent {

  buttonList:ButtonList[] = [];
  
  formGroup: FormGroup = new FormGroup({
    ID: new FormControl<string>('',Validators.required),
  });
  massChange: boolean = false;
  

  save() {
    if ( this.formGroup.valid ){
      this.dialogRef.close(this.formGroup.value);
    }else{
      let tableInformation =
      [{
        colName: 'ID',
        colDesc: 'translate.id.label'
      }];

      tableInformation.push(...this.getLanguage(this.languages));
      this.formGroup.markAllAsTouched();
      this.snackBar.showError(this.fs.getFormErrors(this.formGroup,tableInformation));
    }
  }
  getLanguage(languages: LanguageInterface[]): any {
    let list = languages.map((item) => {
      return {
        colName: item.col,
        colDesc: item.name
      }
    });
    return list;
  }

  constructor(
    public dialogRef: MatDialogRef<TranslateFormNewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fs:FormServices,
    private snackBar:SnackbarService,
    private ls:LanguageServices,
    public ThemeService:ThemeService,
    public spinner:NgxSpinnerService,
  ) {
      this.languages = data.languages;
      this.massChange = data.massChange;

      if ( this.massChange ){
        this.formGroup.removeControl("ID");
      }

      for ( let language of this.languages ){
          this.formGroup.addControl(language.col, new FormControl<string>(null,Validators.required));
      }

      this.buttonList.push({
        color:"primary",
        description:"Salvar",
        action: ()=>{
            this.save();
        }
      },
      {
        color:"warn",
        description:"Cancelar",
        action: ()=>{
            this.dialogRef.close();
        }
      })
  

  }

  languages:  LanguageInterface[] = [];

  onSave(): void {
    // Logic to save the new register
    this.dialogRef.close(this.data);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  translateData(event,item){
    event.stopPropagation();
    event.preventDefault();
    let origemText  = this.formGroup.get("PTBR").value;
    let origemLanguage =  "PTBR";

    if (origemText == null || origemText == ""){
      this.snackBar.showError("translate.error.empty");
      return;
    }
    this.spinner.show(item.col);
    this.ls.getGoogleTranslationLanguages(origemText,origemLanguage,item.col).
      then((data:any) => {
        if ( data != null ){
          let translationsGoogle = JSON.parse(data);
          this.formGroup.get(item.col).patchValue(translationsGoogle['data']['translations'][0]['translatedText']);
          this.formGroup.get(item.col).markAsDirty();
          this.formGroup.get(item.col).markAsTouched();
        }
      }).catch((error:any) => {
        this.snackBar.showError(error.toString());
      }).finally(() => {
        this.spinner.hide(item.col);
      });
    


  }
}
